import React, { useState, useEffect } from "react";
import "./Hero.css";
import Primary from "../buttons/primary/Primary";
import { hero } from "../../data";
import { about } from "../../data";
import { texts } from "../../data";
import { animateMain } from "../../gsap";

const Hero = () => {
  const [flag, setFlag] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const action = () => {
    setFlag(!flag);
  };

  useEffect(() => {
    animateMain();
  }, [flag]);

  window.addEventListener("resize", () => {
    if (window.innerWidth < 688) {
      setFlag(false);
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  });

  return (
    <section className="hero" id="home">
      <div className="hero--box-1">
        <picture>
          <source
            media={`(min-width: 1110px)`}
            srcSet={!flag ? hero.desktop : about.desktop}
          />
          <source
            media={`(min-width: 688px)`}
            srcSet={!flag ? hero.tablet : about.tablet}
          />
          <img
            src={!flag ? hero.mobile : about.mobile}
            className="hero__image"
            alt="hero"
          />
        </picture>
      </div>
      <div className="hero--box-2">
        {!flag ? (
          <h1 className="h2 hero--color">{texts.intro}</h1>
        ) : (
          <h1 className="body-1 hero--color">{texts.aboutme}</h1>
        )}
      </div>
      <div className="hero--box-3">
        <Primary text={"about me"} action={action} disabled={disabled} />
      </div>
      <div className="hero--box-4">
        <h1 className="body-1 hero--color">{texts.aboutme}</h1>
      </div>
    </section>
  );
};

export default Hero;
